
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class IcStockTransferDialog extends Serenity.EntityDialog<IcStockTransferRow, any> {
        protected getFormKey() { return IcStockTransferForm.formKey; }
        protected getIdProperty() { return IcStockTransferRow.idProperty; }
        protected getLocalTextPrefix() { return IcStockTransferRow.localTextPrefix; }
        protected getNameProperty() { return IcStockTransferRow.nameProperty; }
        protected getService() { return IcStockTransferService.baseUrl; }
        protected getDeletePermission() { return IcStockTransferRow.deletePermission; }
        protected getInsertPermission() { return IcStockTransferRow.insertPermission; }
        protected getUpdatePermission() { return IcStockTransferRow.updatePermission; }

        protected form = new IcStockTransferForm(this.idPrefix);
        constructor() {
            super();

            this.form = new IcStockTransferForm(this.idPrefix);
            this.form.PostFg.element.parent();
            (this.form.TransferDtList.view as any).onDataChanged.subscribe(() => {
                let self = this;
                //ui-state-default slick-footerrow-column l0 r0 frozen
                self.element.find(".ui-state-default.slick-footerrow-column.l0.r0.frozen").html("รวม");
            });

            this.form.WhsIdFm.change(e => {
                let orderNo = this.form.WhsIdFm.value
                if (!Q.isEmptyOrNull(orderNo)) {

                    this.form.RefDocNo2.value = null;

                    // pass value into lookup editor and update items
                    this.form.RefDocNo2.myId = orderNo;
                    this.form.RefDocNo2.updateItems();

                    // select first lookup item after changing
                    if (this.form.RefDocNo2.items && this.form.RefDocNo2.items.length > 0) {
                        // Serenity.EditorUtils.setValue(this.form.DocNo, this.form.DocNo.items[0].id);
                    }


                }
            });

            if(this.isNew()){
            this.form.RefDocNo2.change(e => {
                let orderNo = this.form.RefDocNo2.value
                this.form.TransferDtList.Ref2 = this.form.RefDocNo2.value;

            });
        }
        }
        protected initToolbar() {
            super.initToolbar();

        }
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            if (this.isEditMode) {
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
                let newSavePosBtn: Serenity.ToolButton =
                {
                    title: "POST",
                    hint: "Post and Save",
                    separator: false,
                    cssClass: "button-save-post",
                    icon: "fa fa-save",
                    hotkey: 'alt+shift+s',
                    onClick: (e) => {
                        var self = this;
                        if (this.validateForm() && this.validateBeforeSave()) {
                            var options = this.getSaveOptions((response) => {

                                if (this.isEditMode()) {
                                    var id1 = response.EntityId;
                                    if (id1 == null) {
                                        id1 = this.get_entityId();
                                    }
                                    var a = this.loadById(id1);
                                }
                                else {
                                    var a = this.loadById(response.EntityId);
                                }

                                // this.showSaveSuccessMessage(response);
                                Q.confirm('ยืนยันการบันทึกเอกสาร POST', () => {
                                    this.form.PostFg.value = "3";
                                    this.form.PostFg.forceUpdate();
                                    this.save((response1) => {
                                        this.dialogClose();
                                    });
                                });

                            });

                            options.onError = function (response) {
                                Q.alert(response.Error.Message);

                            }

                            Q.serviceCall(options);
                        }




                    }
                };
                buttons.push(newSavePosBtn);
                let newSaveBtn: Serenity.ToolButton =
                {
                    title: "บันทึกเอกสาร แต่ยังไม่ POST",
                    hint: "Save",
                    separator: false,
                    cssClass: "button-save",
                    icon: "fa fa-save",
                    hotkey: 'alt+s',
                    onClick: (e) => {

                        var self = this;


                        if (this.validateForm() && this.validateBeforeSave()) {
                            var options = this.getSaveOptions((response) => {

                                if (this.isEditMode()) {
                                    var id1 = response.EntityId;
                                    if (id1 == null) {
                                        id1 = this.get_entityId();
                                    }
                                    this.loadById(id1);
                                }
                                else {
                                    // this.loadById(response.EntityId);
                                    this.dialogClose();
                                }

                                this.showSaveSuccessMessage(response);


                            });

                            options.onError = function (response) {
                                if (response.Error.Message == "Can't save record. There is another record with the same เลขที่เอกสาร value!") {
                                    Q.alert(response.Error.Message = "เลขที่เอกสารถูกใช้งานแล้ว ระบบจำทำการบรับเลขที่เอกสาร โปรดทำการบันทึกอีกครั้ง");
                                    var s = self.form.SysDocNo.value
                                    var f = s.substring(0, 9)
                                    GeniuzPOS.Inventory.IcStockTransferService.GetNextNumber({
                                        Prefix: f,
                                        Length: 15
                                    }, response => {

                                        self.form.SysDocNo.value = response.Serial;

                                    });
                                } else { Q.alert(response.Error.Message); }



                            }

                            Q.serviceCall(options);
                        } else {
                            this.save((response) => {
                                this.dialogClose();
                            });


                        }

                    }
                };
                buttons.push(newSaveBtn);
                let newDeleteBtn: Serenity.ToolButton =
                {
                    title: "ลบเอกสาร'",
                    hint: "Delete",
                    separator: false,
                    cssClass: "delete-button",
                    icon: "fa fa-save",
                    hotkey: 'alt+x',
                    onClick: (e) => {
                        Q.confirm('ยืนยันการลบเอกสาร', () => {
                            this.form.CancelFg.value = "2";
                            this.save((response) => {
                                this.dialogClose();
                            });
                        });
                    }
                };
                buttons.push(newDeleteBtn);


            }
            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();

                    },
                }
            );
            // this.form.DocNo.change(e => {
            let CallPR: Serenity.ToolButton =
            {
                title: "",
                hint: "call GR detail",
                cssClass: "callpr",
                icon: "fa fa-level-down-alt",

                onClick: (e) => {
                    let orderNo: string = this.form.RefDocNo2.value
                    console.log(orderNo)
                    if (!Q.isEmptyOrNull(orderNo)) {

                        this.form.TransferDtList.CallGR = orderNo

                        var id = Q.tryFirst(IcStockReceiveRow.getLookup().items, x => x.SysDocNo == orderNo).SysDocNo;

                        IcStockReceiveService.Retrieve(
                            {
                                EntityId: id
                            }, response => {
                                this.setHdDetails(response.Entity);
                            }
                        )

                    }
                }
            };
            buttons.push(CallPR);  //CR

            let EditWhs: Serenity.ToolButton = {
                title: "",
                hint: "Edit Whs",
                cssClass: "editwhs",
                icon: "fa fa-edit green", // Changed icon to a more appropriate one
                onClick: (e) => {
                    this.EditWhs(0);
                }
            };
            buttons.push(EditWhs);
            // });

            return buttons;
        }


        public setHdDetails(details: IcStockReceiveRow) {
            //hd
            this.form.RefDocNo1.value = String(details.DocNo ?? '');

            this.form.WhsIdFm.value = String(details.WhsId ?? '');

            this.form.Remark.value = String(details.Remark ?? '');

        }
        protected afterLoadEntity() {
            super.afterLoadEntity();


            this.syscuscheck();

            this.form.TransferDtList.myPassValue = this.entity.SysDocNo
            if (this.entity.PostFg == 1) {
                this.form.TransferDtList.myPassValue2 = this.entity.PostFg;
            } else {
                this.form.TransferDtList.myPassValue2 = 0;
                // this.toolbar.findButton('callpr').insertAfter(this.form.RefDocNo2.element)//CR
            }


            ////----
            let self = this;
            let nbrRetry = 0;
            (function changeTitle() {
                if (nbrRetry >= 10) {
                    return;
                }

                setTimeout(() => {
                    if ((self as any).isMarkedAsPanel === true) {
                        if (self.element.find(".panel-titlebar").length == 1) {
                            // self.element.find(".panel-titlebar").html("");
                            //self.element.find(".panel-titlebar-text").html("");
                            self.element.find(".panel-titlebar-close").html("");//panel-titlebar
                        }
                        else {
                            changeTitle();
                        }
                    }
                    else {
                        if (self.element.parent().find(".panel-titlebar").length == 1) {
                            // self.element.parent().find(".panel-titlebar").html("");
                            // self.element.parent().find(".panel-titlebar-text").html("");
                            self.element.parent().find(".panel-titlebar-close").html("");
                        }
                        else {
                            changeTitle();
                        }
                    }
                }, 100);
            })();


            if (this.entity.PostFg == 1 || this.entity.PostFg == 2 || this.entity.CancelFg == 1) {
                this.toolbar.findButton('creates-followup-button').hide();
                this.toolbar.findButton('genarate-po-button').hide();
                this.toolbar.findButton('button-save-post').hide();
                this.toolbar.findButton('button-save').hide();
                this.toolbar.findButton('apply-changes-button').toggleClass('disabled', false);
                //Serenity.EditorUtils.setReadonly(this.element.find('.editor'), true);
                // this.applyChangesButton.toggleClass('disabled', true);
                // this.saveAndCloseButton.toggleClass('disabled', true);
                this.deleteButton.toggleClass('disabled', true);
                this.form.TransferDtList.set_readOnly(true);
                this.toolbar.findButton('editwhs').remove();
            } else {
                this.toolbar.findButton('apply-changes-button').hide();
                if (this.isNew()) {
                    // this.UserWhs(1);
                    this.EditWhs(0);
                    this.getNextNumber();
                    this.toolbar.findButton('button-save-post').hide();
                    this.toolbar.findButton('delete-button').hide();
                } else {
                    this.EditWhs(1);
                }


            }
        }

        private UserWhs(
            id?: number
        ) {
            var userId = Q.first(Administration.UserRow.getLookup().items, x => x.ShopId == Authorization.userDefinition.ShopId);
            console.log('User Id : ' + userId.ShopId);
            let orderNo = userId.ShopId


            if (id == 1) {
                if (!Q.isEmptyOrNull(orderNo)) {

                    this.form.WhsIdFm.value = null;

                    // pass value into lookup editor and update items
                    this.form.WhsIdFm.myId = orderNo;
                    this.form.WhsIdFm.updateItems();

                    // select first lookup item after changing
                    if (this.form.WhsIdFm.items && this.form.WhsIdFm.items.length > 0) {
                        // Serenity.EditorUtils.setValue(this.form.DocNo, this.form.DocNo.items[0].id);
                    }


                }
            }
        }

        private EditWhs(
            id?: number
        ) {

            if (id == 0) {
                this.form.RefDocNo2.getGridField().toggle(true);
                this.form.ConcatRefDocNo2.getGridField().toggle(false);

                this.form.WhsIdFm.getGridField().toggle(true);
                this.form.ConcatWhsIdFm.getGridField().toggle(false);
                Serenity.EditorUtils.setReadOnly(this.form.WhsIdFm, false);
                this.toolbar.findButton('editwhs').remove();
                this.form.TransferDtList.Ref2 = this.form.RefDocNo2.value;
                this.UserWhs(1);
            } else {
                this.form.WhsIdFm.getGridField().toggle(false);
                this.form.ConcatWhsIdFm.getGridField().toggle(true);

                this.form.RefDocNo2.getGridField().toggle(false);
                this.form.ConcatRefDocNo2.getGridField().toggle(true);

                this.toolbar.findButton('editwhs').insertAfter(this.form.ConcatWhsIdFm.element)
                //this.form.WhsIdFm.updateItems();



            }
        }






        protected getSaveEntity(): IcStockTransferRow {
            let entity = super.getSaveEntity();

            return entity;
        }
        private syscuscheck() {
            let app = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 81 && x.SysFg > 0)
            console.log(app)
            if (app != null) {
                this.toolbar.findButton('callpr').insertAfter(this.form.RefDocNo2.element)
            } else {
                this.toolbar.findButton('callpr').hide();
            }
        }

        private getNextNumber() {
            var val = Q.trimToNull(this.form.SysDocNo.value);



            if (!val || val.length <= 3) {
                var someDate = new Date();
                var dd = someDate.getDate();
                var mm = someDate.getMonth() + 1;
                var myRow = 0;
                var userId = Q.first(Administration.UserRow.getLookup().items, x => x.ShopId == Authorization.userDefinition.ShopId);
                console.log('User Id : ' + userId.ShopId);
                try {
                    var userRole = Q.first(Administration.UserRoleRow.getLookup().items, x => x.UserId == userId.UserId);

                    if (userRole != null) {
                        myRow = userRole.RoleId;
                    }
                    if (userRole != null || userRole.RoleId.valueOf) {
                        myRow = userRole.RoleId;
                    }
                    if (myRow == 1) {
                        //(this.form.SlmnCode.element as any).select2(userId.SlmnCode);
                    }
                } catch {

                }

                var y = someDate.getFullYear();
                var mo = "";
                var ddd = "";

                if (mm < 10) {
                    mo = '0' + mm;

                } else {
                    mo = mm.toString();
                }

                if (dd < 10) {
                    //ddd = '0' + dd;
                    ddd = '';

                } else {
                    //ddd = dd.toString();
                    ddd = '';
                }

                var someFormattedDate = y.toString().substr(2, 2);

                var docprefix = Q.tryFirst(Product.CsDocTypeRow.getLookup().items, x => x.DocType == "35").DocPrefix;
                var prefix = docprefix + userId.ShopId + someFormattedDate + mo + ddd;
                GeniuzPOS.Inventory.IcStockTransferService.GetNextNumber({
                    Prefix: prefix,
                    Length: 15
                }, response => {

                    this.form.SysDocNo.value = response.Serial;
                    this.form.DocDate.element.focus();
                });
            }

        }


    }
}